export const ID = 'EVENTS';

export const ANSWER_INPUT_FOCUSED = `${ID}/ANSWER_INPUT_FOCUSED`;
export const ANSWER_INPUT_FOCUSED_COMPLETED = `${ID}/ANSWER_INPUT_FOCUSED_COMPLETED`;
export const ANSWER_INPUT_FOCUSED_FAILED = `${ID}/ANSWER_INPUT_FOCUSED_FAILED`;
